export function beautifyNumber(num) {
  let result = Number.parseInt(num);
  const numberLength = Math.abs(result).toString().length;
  const pow = Math.max(0, numberLength - 2);
  return result - (result % Math.pow(10, pow));
}

export function roundToNearest(num: number) {
  const numberLength = Math.abs(num).toString().length;
  const precisionTable = [0, 0, 1, 1, 2, 2, 3, 3, 4, 4];
  const precision =
    precisionTable[numberLength] !== undefined
      ? precisionTable[numberLength]
      : 5;

  const base = Math.max(0, precision);
  const pow = Math.pow(10, base);

  return Math.round(num / pow) * pow;
}

export const toAmountShort = (amount: number, lang: string) => {
  if (lang !== 'ja') {
    return toAmountShortGeneric(amount);
  } else {
    // japanese system
    return toAmountShortJP(amount);
  }
};

export const toAmountShortGeneric = (amount: number) => {
  if (amount >= 1e9) {
    return `${toShort(amount)}B`;
  } else if (amount >= 1e6) {
    return `${toShort(amount)}M`;
  } else if (amount >= 1e3) {
    return `${toShort(amount)}K`;
  } else {
    return parseAmount(amount);
  }
};

export const toAmountShortJP = (amount: number) => {
  if (amount >= 1e12) {
    return `${toShortJP(amount)}兆`;
  } else if (amount >= 1e8) {
    return `${toShortJP(amount)}億`;
  } else if (amount >= 1e4) {
    return `${toShortJP(amount)}万`;
  } else if (amount >= 1e3) {
    return `${toShortJP(amount)}千`;
  } else {
    return parseAmount(amount);
  }
};

export const parseAmount = (amount: string | number) => {
  if (!amount) return '0';
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  // return formatter.format(amount); /* $2,500.00 */
};

export function toShort(amount: number): string {
  let short = amount;

  // Make it short
  if (amount >= 1e9) {
    short /= 1e9;
  } else if (amount >= 1e6) {
    short /= 1e6;
  } else if (amount >= 1e3) {
    short /= 1e3;
  } else {
    return amount.toString(); // its already short enough
  }

  // Get integer part of float 15.4 => 15, -0.323 => -0 etc
  const integerPart = Math.trunc(short);

  // This will work only for integers!
  const digitsCount = Math.abs(integerPart).toString().length;

  // Cut decimal part
  // if digitsCount === 1 toFixed == 2
  // if digitsCount === 2 toFixed == 1
  // if digitsCount >= 3 toFixed == 0
  // Standard toFixed() func has rounding side effect we don't want this, so we have to use simple string cut solution instead
  const shortFloatString = toFixedTrunc(short, Math.max(0, 3 - digitsCount));

  // Truncate last zeroes
  return parseFloat(shortFloatString).toString();
}

export function toShortJP(amount: number): string {
  // CHOU 1 trillion
  // OKU 10 million,
  // MAN - 10 000
  // ZEN - 1000
  let short = amount;
  if (amount >= 1e12) {
    // CHOU
    short /= 1e12;
  } else if (amount >= 1e8) {
    // OKU
    short /= 1e8;
  } else if (amount >= 1e4) {
    // MAN
    short /= 1e4;
  } else if (amount >= 1e3) {
    // ZEN
    short /= 1e3;
  } else {
    return amount.toString(); // its already short enough
  }

  // Get integer part of float 15.4 => 15, -0.323 => -0 etc
  const integerPart = Math.trunc(short);

  // This will work only for integers!
  const digitsCount = Math.abs(integerPart).toString().length;

  // Cut decimal part
  // if digitsCount === 1 toFixed == 2
  // if digitsCount === 2 toFixed == 1
  // if digitsCount >= 3 toFixed == 0
  // Standard toFixed() func has rounding side effect we don't want this, so we have to use simple string cut solution instead
  const shortFloatString = toFixedTrunc(short, Math.max(0, 3 - digitsCount));

  // Truncate last zeroes
  return parseFloat(shortFloatString).toString();
}

// See: https://stackoverflow.com/questions/4912788/truncate-not-round-off-decimal-numbers-in-javascript
export function toFixedTrunc(number: number, digits: number): string {
  if (isNaN(number)) return '0';
  const num = Math.trunc(number * Math.pow(10, digits)) / Math.pow(10, digits);
  return num.toString();
}
